/*global FB*/

export const FBLogin = () => new Promise(resolve => FB.login(resolve, { scope: 'public_profile, email' }))

export const FBShare = (href, title='', description='', trackApp='') => new Promise((resolve, reject) => {
  FB.ui({ method: 'share', href: href, title: title, description: description }, (response) => {
    if (response && !response.error_code) {
      //const app = trackApp ? trackApp + '_' : '';
      //mixpanel.track(`XP_${app}facebook_post`);
      resolve(response)
    } else {
      reject(response)
    }
  })
})



// WEBPACK FOOTER //
// ./src/util/facebook.js